module.exports = __webpack_public_path__ + "static/media/adultomayor.741aef11.png";